// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overview — restrained, professional. Company purple is the only accent
   (live-chat toggle + success ring keep their own status colours). Neutral
   borders, very light shadows, smooth cubic-bezier hovers — matching the
   language used in bots.css. */

.ov-page {
  display: flex;
  flex-direction: column;
  gap: 18px;
  /* Same logic as the marketing \`w-10xl\` utility: max-width is driven by
     --max-width-10xl (120rem), with the value inlined as a fallback since
     the variable isn't defined in the portal. */
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  padding: 22px 24px 48px;
  font-family: "DM Sans", sans-serif;
  color: #2b2b35;
}

.ov-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: #5616ea;
  font-size: 22px;
}

/* ── Page header (bot name + rename) ───────────────────────────────── */
.ov-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 38px;
}
.ov-top-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.15;
  color: #20202a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ov-rename-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 13px;
  border: 1px solid #e4e4ea;
  border-radius: 8px;
  background: #fff;
  color: #5a5a66;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}
.ov-rename-btn svg {
  font-size: 11px;
}
.ov-rename-btn:hover {
  background: #f7f4ff;
  border-color: #cbb9f4;
  color: #5616ea;
}
/* back to the AI Studio start page (the classic overview is opt-in) */
.ov-studio-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border: 1px solid #cbb9f4;
  border-radius: 8px;
  background: #f7f4ff;
  color: #5616ea;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.3s ease, color 0.3s ease;
}
.ov-studio-btn svg {
  font-size: 12px;
}
.ov-studio-btn:hover {
  background: #5616ea;
  color: #fff;
}
@media (max-width: 560px) {
  .ov-top {
    flex-wrap: wrap;
  }
  .ov-top-title {
    min-width: 0;
    flex: 1 1 auto;
  }
  .ov-studio-btn {
    margin-left: 0;
  }
}
.ov-rename-input {
  font-family: inherit;
  font-size: 1.4rem;
  font-weight: 700;
  color: #20202a;
  padding: 4px 10px;
  border: 1px solid #cbb9f4;
  border-radius: 8px;
  outline: none;
  min-width: 240px;
  max-width: 100%;
  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.12);
}

/* ── Card base ─────────────────────────────────────────────────────── */
.ov-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: none;
}

/* ── Two-pane layout: chat playground (left) + everything else (right) ──
   A fixed-height row that fills the viewport below the app header, page
   padding and the title; each pane scrolls internally. The offset subtracts
   app header (56) + page top padding (22) + title row (~38) + the page gap
   (18) + bottom padding (48). Tune the offset if the page starts scrolling. */
.ov-split {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  /* Explicit single row pinned to the full container height so both columns
     are definitively full-height — this is what lets the right column's
     Activity card actually grow to fill (an implicit auto row left it short). */
  grid-template-rows: minmax(0, 1fr);
  column-gap: 34px;
  row-gap: 24px;
  height: calc(100vh - 182px);
  min-height: 520px;
  max-height: 1200px;
}
.ov-split-left {
  min-width: 0;
  min-height: 0;
  /* The embedded ChatModal fills this and manages its own scrolling. Clip to
     the cell so the chat can't spill below it — otherwise the playground
     renders taller than the right column and their bottoms don't line up. */
  overflow: hidden;
}
.ov-split-right {
  min-width: 0;
  min-height: 0;
  /* Grid (not flex): the three top cards take their natural height and the
     Activity card occupies the final 1fr row, which reliably fills any
     leftover height — flex-grow inside this overflow container did not.
     The last row uses an \`auto\` minimum (not 0): when this column overflows
     and a scrollbar appears, a \`minmax(0, 1fr)\` row collapses below the card's
     content so the chart/footer spill past the white card background. \`auto\`
     keeps the row at least as tall as the card's content, so the white box
     always wraps it and the column simply scrolls. */
  display: grid;
  grid-template-rows: repeat(3, auto) minmax(auto, 1fr);
  gap: 16px;
  overflow-y: auto;
  padding-right: 4px;
  /* Every card in this column lifts 1px on hover. Without this the FIRST card's
     top border is pushed outside the scroll container and disappears mid-hover
     (visible on Live chat, and on the knowledge nudge when it is shown). */
  padding-top: 2px;
}
/* The knowledge-freshness nudge is a conditional FIFTH child. Without this the
   template's 1fr row would land on Success score and Activity would fall into an
   implicit auto row, losing the fill-the-leftover-height behaviour above.
   Browsers without :has() simply keep the previous (still readable) layout. */
.ov-split-right:has(> .ov-action-stale) {
  grid-template-rows: auto repeat(3, auto) minmax(auto, 1fr);
}
/* Activity fills the 1fr row; its chart stretches to fill the card. */
.ov-split-right > .ov-activity {
  display: flex;
  flex-direction: column;
  min-height: 320px;
}
.ov-split-right > .ov-activity .ov-chart {
  /* flex-shrink enabled + min-height:0 lets the chart give up height so the
     header + chart + footer always sum to the card height — the footer can
     never spill below the white background. The card's min-height keeps the
     chart a sensible size; when there's room, 1fr makes both grow. */
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
}

/* ── 2×2 grid ──────────────────────────────────────────────────────── */
.ov-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.ov-tile {
  display: flex;
  flex-direction: column;
  padding: 20px 22px;
  text-align: left;
  min-height: 182px;
}

.ov-tile-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 12px;
}
.ov-tile-ic {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #f3f0fc;
  color: #5616ea;
  font-size: 15px;
  flex-shrink: 0;
}
/* Title + subtitle stack between the icon and the right-side plan/tag. */
.ov-tile-titles {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.ov-tile-title {
  font-size: 15px;
  font-weight: 700;
  color: #20202a;
}
.ov-tile-sub {
  font-size: 12px;
  color: #82828e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ov-tile-tag {
  font-size: 11px;
  font-weight: 600;
  color: #5616ea;
  background: #f3f0fc;
  border-radius: 6px;
  padding: 3px 9px;
  white-space: nowrap;
}
.ov-tile-plan {
  display: inline-flex;
  align-items: baseline;
  gap: 7px;
  white-space: nowrap;
  flex-shrink: 0;
}
.ov-tile-plan-label {
  font-size: 11px;
  font-weight: 500;
  color: #9a96ab;
}
.ov-tile-plan-name {
  font-size: 11px;
  font-weight: 700;
  color: #5616ea;
  background: #f3f0fc;
  border-radius: 6px;
  padding: 3px 9px;
}
/* ── Compact action cards (Test bot + Live chat) ───────────────────── */
.ov-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.ov-action {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 14px 16px;
  text-align: left;
}
.ov-action-ic {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: #f3f0fc;
  color: #5616ea;
  font-size: 15px;
  flex-shrink: 0;
}
.ov-action-body {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.ov-action-title {
  font-size: 14px;
  font-weight: 700;
  color: #20202a;
}
.ov-action-sub {
  font-size: 12px;
  color: #82828e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ov-action-side {
  flex-shrink: 0;
}
/* Knowledge-freshness nudge: an amber accent so it reads as "worth doing"
   without the alarm of a real error state. The room its hover lift needs comes
   from .ov-split-right's padding-top, which covers whichever card is first. */
.ov-action-stale {
  border-color: #ffdb9a;
  background: #fffdf7;
}
.ov-action-stale .ov-action-ic {
  background: #fff1d2;
  color: #e07b00;
  font-size: 18px;
}
/* Two classes so this beats .ov-action-clickable:hover regardless of source
   order — otherwise the shared purple hover border wins on this amber card. */
.ov-action.ov-action-stale:hover {
  border-color: #ef9a26;
}
/* The sibling action cards are one-line labels; this one carries a sentence,
   so it wraps to at most two lines instead of ellipsing away the point. */
.ov-action-stale .ov-action-sub {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.45;
}

.ov-action-clickable {
  cursor: pointer;
  font-family: inherit;
  will-change: transform;
  backface-visibility: hidden;
  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ov-action-clickable:hover {
  border-color: #cbb9f4;
  transform: translateY(-1px);
}
.ov-action-cta {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  transition: background-color 0.3s ease;
}
.ov-action-clickable:hover .ov-action-cta {
  background: #4a14d6;
}

/* ── Buttons ───────────────────────────────────────────────────────── */
.ov-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  will-change: transform;
  backface-visibility: hidden;
  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ov-btn-primary {
  background-color: #5616ea;
  color: #fff;
}
.ov-btn-primary:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}
.ov-btn-soft {
  background-color: #f4f1fd;
  color: #5616ea;
}
.ov-btn-soft:hover {
  background-color: #ece5fb;
  transform: translateY(-1px);
}
.ov-tile-cta-soft {
  align-self: flex-end;
}
.ov-tile-cta-soft svg {
  font-size: 11px;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ov-tile-cta-soft:hover svg {
  transform: translateX(3px);
}

/* ── AI responses ──────────────────────────────────────────────────── */
.ov-usage-block {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ov-usage-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.ov-usage-value {
  font-size: 1.9rem;
  font-weight: 700;
  color: #20202a;
  line-height: 1;
  white-space: nowrap;
}
.ov-usage-pct {
  font-size: 12.5px;
  font-weight: 600;
  color: #82828e;
  white-space: nowrap;
  text-align: right;
}
.ov-usage-sub {
  font-size: 1.05rem;
  font-weight: 600;
  color: #adadb8;
}
.ov-usage-track {
  margin-top: 13px;
  height: 8px;
  border-radius: 6px;
  background: #ededf1;
  overflow: hidden;
}
.ov-usage-fill {
  height: 100%;
  border-radius: 6px;
  background: #5616ea;
  /* width transition handles live increments (usage ticking up); the scaleX
     keyframe sweeps the bar in from the left on first paint. Animating
     transform (not width) means the reveal works regardless of the bar's
     dynamic target width. */
  transition: width 0.3s ease;
  transform-origin: left center;
  animation: ov-bar-grow 0.85s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.ov-usage-fill.full {
  background: #ef4444;
}
@keyframes ov-bar-grow {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ov-usage-fill {
    animation: none;
  }
}

/* ── Success score ─────────────────────────────────────────────────── */
.ov-tile-score {
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}
.ov-tile-score:hover {
  border-color: #cbb9f4;
  transform: translateY(-1px);
}
.ov-score-body {
  flex: 1 1 auto;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}
.ov-ring {
  position: relative;
  width: 104px;
  height: 104px;
  flex-shrink: 0;
}
.ov-ring svg {
  width: 100%;
  height: 100%;
}
.ov-ring-track {
  fill: none;
  stroke: #ededf1;
  stroke-width: 4;
}
.ov-ring-value {
  fill: none;
  stroke-width: 4;
  stroke-linecap: round;
  /* The fill is driven frame-by-frame in JS (useCountUp) so it stays in sync
     with the percentage label — no CSS transition, which would fight it. */
}
.ov-ring-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ov-ring-pct {
  font-size: 1.5rem;
  font-weight: 700;
}
.ov-ring-pct i {
  font-style: normal;
  font-size: 1em;
  margin-left: 1px;
}
.ov-score-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  color: #c8c8d2;
  font-size: 20px;
  flex-shrink: 0;
}
.ov-score-cta {
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  background: #f4f1fd;
  color: #5616ea;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}
.ov-tile-score:hover .ov-score-cta {
  background: #ece5fb;
}
.ov-score-cta svg {
  font-size: 11px;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ov-tile-score:hover .ov-score-cta svg {
  transform: translateX(3px);
}

/* ── Activity ──────────────────────────────────────────────────────── */
.ov-activity {
  padding: 20px 24px 14px;
}
.ov-activity-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
/* Icon + title/sub on the left of the Activity header — uses the same
   .ov-tile-ic purple square as the other tiles. */
.ov-activity-title-group {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}
.ov-section-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #20202a;
}
.ov-section-sub {
  margin: 3px 0 0;
  font-size: 13px;
  color: #82828e;
}
/* Right side of the Activity header: range switcher stacked over the total. */
.ov-activity-head-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  flex-shrink: 0;
}
/* Segmented 7 / 14 / 31 / 90-day range control. A single white thumb slides
   behind the labels; keep the 3px padding in sync with the thumb's inset and
   the inline width calc in Overview.js (100% - 6px). */
.ov-range {
  position: relative;
  display: inline-flex;
  /* Load-bearing: the buttons are fixed-width and the thumb is a fraction of
     this track, so the track MUST stay its natural (buttons') width. Without
     this, the flexible mobile header row squeezed it and 31/90 slid off the
     purple background. Do not remove. */
  flex-shrink: 0;
  padding: 3px;
  background: #f4f1fd;
  border-radius: 9px;
}
/* The sliding white background. Width + transform are set inline (driven by
   the option count and selected index). */
.ov-range-thumb {
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 3px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(86, 22, 234, 0.18);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}
.ov-range-btn {
  position: relative; /* sit above the thumb */
  z-index: 1;
  /* Equal fixed width so the four slots are uniform and the thumb lines up
     exactly (the control is shrink-to-fit, so flex:1 wouldn't equalise them). */
  flex: 0 0 48px;
  box-sizing: border-box;
  border: none;
  background: transparent;
  color: #82828e;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
  transition: color 0.2s ease;
}
.ov-range-btn:hover {
  color: #5616ea;
}
.ov-range-btn.active {
  color: #5616ea;
}
@media (prefers-reduced-motion: reduce) {
  .ov-range-thumb {
    transition: none;
  }
}
.ov-activity-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.1;
}
.ov-activity-total-num {
  font-size: 1.55rem;
  font-weight: 700;
  color: #20202a;
}
.ov-activity-total-lbl {
  font-size: 12px;
  color: #82828e;
}
.ov-chart {
  height: 220px;
  margin-top: 6px;
}
.ov-chart-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #c8c8d2;
  font-size: 22px;
}
.ov-chart-tooltip {
  background: #20202a;
  color: #fff;
  border-radius: 7px;
  padding: 6px 10px;
  font-size: 12px;
}
.ov-chart-tooltip-date {
  opacity: 0.7;
  font-size: 11px;
  margin-bottom: 1px;
}
.ov-chart-tooltip-value {
  font-weight: 700;
}
.ov-activity-foot {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f0f4;
  margin-top: 6px;
  padding-top: 12px;
}
.ov-explore {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: #f4f1fd;
  color: #5616ea;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.ov-explore:hover {
  background: #ece5fb;
}
.ov-explore svg {
  font-size: 11px;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ov-explore:hover svg {
  transform: translateX(3px);
}

/* ── Responsive ────────────────────────────────────────────────────── */
@media (max-width: 820px) {
  /* Belt-and-braces against horizontal overflow: the page never grows wider
     than the viewport, so every card keeps its right padding and nothing runs
     under the screen edge. */
  .ov-page {
    padding: 16px 14px 36px;
    max-width: 100%;
    overflow-x: hidden;
  }

  .ov-actions,
  .ov-grid {
    grid-template-columns: 1fr;
  }

  /* Stack the two panes: playground on top, the cards below. */
  .ov-split {
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 0;
    max-height: none;
    gap: 16px;
  }
  /* Both panes must be allowed to shrink (flex items default to min-width:auto,
     which is what lets inner content force the page wider than the screen). */
  .ov-split-left,
  .ov-split-right {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
  /* Playground: a bounded height so the embedded chat fills it and its input
     stays pinned + visible at the bottom (the chat scrolls internally). */
  .ov-split-left {
    height: 68dvh;
    min-height: 400px;
  }
  /* Cards: a plain full-width stack (grid -> flex; no internal scroll needed). */
  .ov-split-right {
    display: flex;
    flex-direction: column;
    overflow: visible;
    height: auto;
    min-height: 0;
    padding-right: 0;
    gap: 16px;
  }
  .ov-split-right > .ov-activity {
    min-height: 0;
  }
  /* The card is content-height on mobile (no 1fr grid row to fill), so the
     chart's desktop \`flex:1 1 auto; height:auto\` collapses it to 0 and recharts'
     ResponsiveContainer renders nothing. Give the chart a fixed height back. */
  .ov-split-right > .ov-activity .ov-chart {
    flex: 0 0 auto;
    height: 200px;
    min-height: 200px;
  }

  /* Activity header stacks so the range switcher + total don't crowd the title.
     The range control stays its natural compact size (NOT full-width) and sits
     on its own row with the total beside it. */
  .ov-activity {
    padding: 18px 16px 14px;
  }
  .ov-activity-head {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
  .ov-activity-head-right {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px 14px;
    width: 100%;
  }
  /* Slightly tighter pills so the range + total fit one row even on ~320px. */
  .ov-range-btn {
    flex: 0 0 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Overview.css"],"names":[],"mappings":"AAAA;;;+BAG+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;gDAE8C;EAC9C,wCAAwC;EACxC,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+EAA+E;AACjF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uDAAuD;AACzD;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;8EAI8E;AAC9E;EACE,aAAa;EACb,0DAA0D;EAC1D;;gFAE8E;EAC9E,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb;;4EAE0E;EAC1E,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb;;;;;;;qDAOmD;EACnD,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB;;2EAEyE;EACzE,gBAAgB;AAClB;AACA;;;8EAG8E;AAC9E;EACE,0DAA0D;AAC5D;AACA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE;;;qEAGmE;EACnE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,yEAAyE;AACzE;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;8EAE8E;AAC9E;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;8EAC8E;AAC9E;EACE,qBAAqB;AACvB;AACA;0EAC0E;AAC1E;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,wFAAwF;AAC1F;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,4FAA4F;AAC9F;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB;;;4BAG0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,sEAAsE;AACxE;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,oBAAoB;EACpB,wFAAwF;EACxF,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB;2EACyE;AAC3E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;kDACkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;AACA;;uDAEuD;AACvD;EACE,kBAAkB;EAClB,oBAAoB;EACpB;;;wCAGsC;EACtC,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;0CAC0C;AAC1C;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,wDAAwD;EACxD,oBAAoB;AACtB;AACA;EACE,kBAAkB,EAAE,wBAAwB;EAC5C,UAAU;EACV;gFAC8E;EAC9E,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE;;6BAE2B;EAC3B;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;EACA;8EAC4E;EAC5E;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;0EACwE;EACxE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA,+EAA+E;EAC/E;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;;+EAE6E;EAC7E;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;;EAEA;;+CAE6C;EAC7C;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,WAAW;EACb;EACA,4EAA4E;EAC5E;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Overview — restrained, professional. Company purple is the only accent\r\n   (live-chat toggle + success ring keep their own status colours). Neutral\r\n   borders, very light shadows, smooth cubic-bezier hovers — matching the\r\n   language used in bots.css. */\r\n\r\n.ov-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  /* Same logic as the marketing `w-10xl` utility: max-width is driven by\r\n     --max-width-10xl (120rem), with the value inlined as a fallback since\r\n     the variable isn't defined in the portal. */\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  padding: 22px 24px 48px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #2b2b35;\r\n}\r\n\r\n.ov-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 60vh;\r\n  color: #5616ea;\r\n  font-size: 22px;\r\n}\r\n\r\n/* ── Page header (bot name + rename) ───────────────────────────────── */\r\n.ov-top {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  min-height: 38px;\r\n}\r\n.ov-top-title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  line-height: 1.15;\r\n  color: #20202a;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.ov-rename-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 7px 13px;\r\n  border: 1px solid #e4e4ea;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #5a5a66;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;\r\n}\r\n.ov-rename-btn svg {\r\n  font-size: 11px;\r\n}\r\n.ov-rename-btn:hover {\r\n  background: #f7f4ff;\r\n  border-color: #cbb9f4;\r\n  color: #5616ea;\r\n}\r\n/* back to the AI Studio start page (the classic overview is opt-in) */\r\n.ov-studio-btn {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 7px 14px;\r\n  border: 1px solid #cbb9f4;\r\n  border-radius: 8px;\r\n  background: #f7f4ff;\r\n  color: #5616ea;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n.ov-studio-btn svg {\r\n  font-size: 12px;\r\n}\r\n.ov-studio-btn:hover {\r\n  background: #5616ea;\r\n  color: #fff;\r\n}\r\n@media (max-width: 560px) {\r\n  .ov-top {\r\n    flex-wrap: wrap;\r\n  }\r\n  .ov-top-title {\r\n    min-width: 0;\r\n    flex: 1 1 auto;\r\n  }\r\n  .ov-studio-btn {\r\n    margin-left: 0;\r\n  }\r\n}\r\n.ov-rename-input {\r\n  font-family: inherit;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n  padding: 4px 10px;\r\n  border: 1px solid #cbb9f4;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  min-width: 240px;\r\n  max-width: 100%;\r\n  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.12);\r\n}\r\n\r\n/* ── Card base ─────────────────────────────────────────────────────── */\r\n.ov-card {\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  box-shadow: none;\r\n}\r\n\r\n/* ── Two-pane layout: chat playground (left) + everything else (right) ──\r\n   A fixed-height row that fills the viewport below the app header, page\r\n   padding and the title; each pane scrolls internally. The offset subtracts\r\n   app header (56) + page top padding (22) + title row (~38) + the page gap\r\n   (18) + bottom padding (48). Tune the offset if the page starts scrolling. */\r\n.ov-split {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);\r\n  /* Explicit single row pinned to the full container height so both columns\r\n     are definitively full-height — this is what lets the right column's\r\n     Activity card actually grow to fill (an implicit auto row left it short). */\r\n  grid-template-rows: minmax(0, 1fr);\r\n  column-gap: 34px;\r\n  row-gap: 24px;\r\n  height: calc(100vh - 182px);\r\n  min-height: 520px;\r\n  max-height: 1200px;\r\n}\r\n.ov-split-left {\r\n  min-width: 0;\r\n  min-height: 0;\r\n  /* The embedded ChatModal fills this and manages its own scrolling. Clip to\r\n     the cell so the chat can't spill below it — otherwise the playground\r\n     renders taller than the right column and their bottoms don't line up. */\r\n  overflow: hidden;\r\n}\r\n.ov-split-right {\r\n  min-width: 0;\r\n  min-height: 0;\r\n  /* Grid (not flex): the three top cards take their natural height and the\r\n     Activity card occupies the final 1fr row, which reliably fills any\r\n     leftover height — flex-grow inside this overflow container did not.\r\n     The last row uses an `auto` minimum (not 0): when this column overflows\r\n     and a scrollbar appears, a `minmax(0, 1fr)` row collapses below the card's\r\n     content so the chart/footer spill past the white card background. `auto`\r\n     keeps the row at least as tall as the card's content, so the white box\r\n     always wraps it and the column simply scrolls. */\r\n  display: grid;\r\n  grid-template-rows: repeat(3, auto) minmax(auto, 1fr);\r\n  gap: 16px;\r\n  overflow-y: auto;\r\n  padding-right: 4px;\r\n  /* Every card in this column lifts 1px on hover. Without this the FIRST card's\r\n     top border is pushed outside the scroll container and disappears mid-hover\r\n     (visible on Live chat, and on the knowledge nudge when it is shown). */\r\n  padding-top: 2px;\r\n}\r\n/* The knowledge-freshness nudge is a conditional FIFTH child. Without this the\r\n   template's 1fr row would land on Success score and Activity would fall into an\r\n   implicit auto row, losing the fill-the-leftover-height behaviour above.\r\n   Browsers without :has() simply keep the previous (still readable) layout. */\r\n.ov-split-right:has(> .ov-action-stale) {\r\n  grid-template-rows: auto repeat(3, auto) minmax(auto, 1fr);\r\n}\r\n/* Activity fills the 1fr row; its chart stretches to fill the card. */\r\n.ov-split-right > .ov-activity {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 320px;\r\n}\r\n.ov-split-right > .ov-activity .ov-chart {\r\n  /* flex-shrink enabled + min-height:0 lets the chart give up height so the\r\n     header + chart + footer always sum to the card height — the footer can\r\n     never spill below the white background. The card's min-height keeps the\r\n     chart a sensible size; when there's room, 1fr makes both grow. */\r\n  flex: 1 1 auto;\r\n  height: auto;\r\n  min-height: 0;\r\n}\r\n\r\n/* ── 2×2 grid ──────────────────────────────────────────────────────── */\r\n.ov-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n}\r\n\r\n.ov-tile {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px 22px;\r\n  text-align: left;\r\n  min-height: 182px;\r\n}\r\n\r\n.ov-tile-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  margin-bottom: 12px;\r\n}\r\n.ov-tile-ic {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 8px;\r\n  background: #f3f0fc;\r\n  color: #5616ea;\r\n  font-size: 15px;\r\n  flex-shrink: 0;\r\n}\r\n/* Title + subtitle stack between the icon and the right-side plan/tag. */\r\n.ov-tile-titles {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n}\r\n.ov-tile-title {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.ov-tile-sub {\r\n  font-size: 12px;\r\n  color: #82828e;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.ov-tile-tag {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  background: #f3f0fc;\r\n  border-radius: 6px;\r\n  padding: 3px 9px;\r\n  white-space: nowrap;\r\n}\r\n.ov-tile-plan {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 7px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n.ov-tile-plan-label {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #9a96ab;\r\n}\r\n.ov-tile-plan-name {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #5616ea;\r\n  background: #f3f0fc;\r\n  border-radius: 6px;\r\n  padding: 3px 9px;\r\n}\r\n/* ── Compact action cards (Test bot + Live chat) ───────────────────── */\r\n.ov-actions {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n}\r\n.ov-action {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 13px;\r\n  padding: 14px 16px;\r\n  text-align: left;\r\n}\r\n.ov-action-ic {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 8px;\r\n  background: #f3f0fc;\r\n  color: #5616ea;\r\n  font-size: 15px;\r\n  flex-shrink: 0;\r\n}\r\n.ov-action-body {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n}\r\n.ov-action-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.ov-action-sub {\r\n  font-size: 12px;\r\n  color: #82828e;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.ov-action-side {\r\n  flex-shrink: 0;\r\n}\r\n/* Knowledge-freshness nudge: an amber accent so it reads as \"worth doing\"\r\n   without the alarm of a real error state. The room its hover lift needs comes\r\n   from .ov-split-right's padding-top, which covers whichever card is first. */\r\n.ov-action-stale {\r\n  border-color: #ffdb9a;\r\n  background: #fffdf7;\r\n}\r\n.ov-action-stale .ov-action-ic {\r\n  background: #fff1d2;\r\n  color: #e07b00;\r\n  font-size: 18px;\r\n}\r\n/* Two classes so this beats .ov-action-clickable:hover regardless of source\r\n   order — otherwise the shared purple hover border wins on this amber card. */\r\n.ov-action.ov-action-stale:hover {\r\n  border-color: #ef9a26;\r\n}\r\n/* The sibling action cards are one-line labels; this one carries a sentence,\r\n   so it wraps to at most two lines instead of ellipsing away the point. */\r\n.ov-action-stale .ov-action-sub {\r\n  white-space: normal;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  line-height: 1.45;\r\n}\r\n\r\n.ov-action-clickable {\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ov-action-clickable:hover {\r\n  border-color: #cbb9f4;\r\n  transform: translateY(-1px);\r\n}\r\n.ov-action-cta {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  flex-shrink: 0;\r\n  transition: background-color 0.3s ease;\r\n}\r\n.ov-action-clickable:hover .ov-action-cta {\r\n  background: #4a14d6;\r\n}\r\n\r\n/* ── Buttons ───────────────────────────────────────────────────────── */\r\n.ov-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ov-btn-primary {\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n}\r\n.ov-btn-primary:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n.ov-btn-soft {\r\n  background-color: #f4f1fd;\r\n  color: #5616ea;\r\n}\r\n.ov-btn-soft:hover {\r\n  background-color: #ece5fb;\r\n  transform: translateY(-1px);\r\n}\r\n.ov-tile-cta-soft {\r\n  align-self: flex-end;\r\n}\r\n.ov-tile-cta-soft svg {\r\n  font-size: 11px;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ov-tile-cta-soft:hover svg {\r\n  transform: translateX(3px);\r\n}\r\n\r\n/* ── AI responses ──────────────────────────────────────────────────── */\r\n.ov-usage-block {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n.ov-usage-row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n.ov-usage-value {\r\n  font-size: 1.9rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n}\r\n.ov-usage-pct {\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: #82828e;\r\n  white-space: nowrap;\r\n  text-align: right;\r\n}\r\n.ov-usage-sub {\r\n  font-size: 1.05rem;\r\n  font-weight: 600;\r\n  color: #adadb8;\r\n}\r\n.ov-usage-track {\r\n  margin-top: 13px;\r\n  height: 8px;\r\n  border-radius: 6px;\r\n  background: #ededf1;\r\n  overflow: hidden;\r\n}\r\n.ov-usage-fill {\r\n  height: 100%;\r\n  border-radius: 6px;\r\n  background: #5616ea;\r\n  /* width transition handles live increments (usage ticking up); the scaleX\r\n     keyframe sweeps the bar in from the left on first paint. Animating\r\n     transform (not width) means the reveal works regardless of the bar's\r\n     dynamic target width. */\r\n  transition: width 0.3s ease;\r\n  transform-origin: left center;\r\n  animation: ov-bar-grow 0.85s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n.ov-usage-fill.full {\r\n  background: #ef4444;\r\n}\r\n@keyframes ov-bar-grow {\r\n  from {\r\n    transform: scaleX(0);\r\n  }\r\n  to {\r\n    transform: scaleX(1);\r\n  }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .ov-usage-fill {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* ── Success score ─────────────────────────────────────────────────── */\r\n.ov-tile-score {\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n.ov-tile-score:hover {\r\n  border-color: #cbb9f4;\r\n  transform: translateY(-1px);\r\n}\r\n.ov-score-body {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n}\r\n.ov-ring {\r\n  position: relative;\r\n  width: 104px;\r\n  height: 104px;\r\n  flex-shrink: 0;\r\n}\r\n.ov-ring svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.ov-ring-track {\r\n  fill: none;\r\n  stroke: #ededf1;\r\n  stroke-width: 4;\r\n}\r\n.ov-ring-value {\r\n  fill: none;\r\n  stroke-width: 4;\r\n  stroke-linecap: round;\r\n  /* The fill is driven frame-by-frame in JS (useCountUp) so it stays in sync\r\n     with the percentage label — no CSS transition, which would fight it. */\r\n}\r\n.ov-ring-center {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.ov-ring-pct {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n}\r\n.ov-ring-pct i {\r\n  font-style: normal;\r\n  font-size: 1em;\r\n  margin-left: 1px;\r\n}\r\n.ov-score-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 104px;\r\n  height: 104px;\r\n  color: #c8c8d2;\r\n  font-size: 20px;\r\n  flex-shrink: 0;\r\n}\r\n.ov-score-cta {\r\n  align-self: flex-end;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  background: #f4f1fd;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: background-color 0.3s ease;\r\n}\r\n.ov-tile-score:hover .ov-score-cta {\r\n  background: #ece5fb;\r\n}\r\n.ov-score-cta svg {\r\n  font-size: 11px;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ov-tile-score:hover .ov-score-cta svg {\r\n  transform: translateX(3px);\r\n}\r\n\r\n/* ── Activity ──────────────────────────────────────────────────────── */\r\n.ov-activity {\r\n  padding: 20px 24px 14px;\r\n}\r\n.ov-activity-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n/* Icon + title/sub on the left of the Activity header — uses the same\r\n   .ov-tile-ic purple square as the other tiles. */\r\n.ov-activity-title-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  min-width: 0;\r\n}\r\n.ov-section-title {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.ov-section-sub {\r\n  margin: 3px 0 0;\r\n  font-size: 13px;\r\n  color: #82828e;\r\n}\r\n/* Right side of the Activity header: range switcher stacked over the total. */\r\n.ov-activity-head-right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n}\r\n/* Segmented 7 / 14 / 31 / 90-day range control. A single white thumb slides\r\n   behind the labels; keep the 3px padding in sync with the thumb's inset and\r\n   the inline width calc in Overview.js (100% - 6px). */\r\n.ov-range {\r\n  position: relative;\r\n  display: inline-flex;\r\n  /* Load-bearing: the buttons are fixed-width and the thumb is a fraction of\r\n     this track, so the track MUST stay its natural (buttons') width. Without\r\n     this, the flexible mobile header row squeezed it and 31/90 slid off the\r\n     purple background. Do not remove. */\r\n  flex-shrink: 0;\r\n  padding: 3px;\r\n  background: #f4f1fd;\r\n  border-radius: 9px;\r\n}\r\n/* The sliding white background. Width + transform are set inline (driven by\r\n   the option count and selected index). */\r\n.ov-range-thumb {\r\n  position: absolute;\r\n  top: 3px;\r\n  bottom: 3px;\r\n  left: 3px;\r\n  background: #fff;\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 2px rgba(86, 22, 234, 0.18);\r\n  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\r\n  pointer-events: none;\r\n}\r\n.ov-range-btn {\r\n  position: relative; /* sit above the thumb */\r\n  z-index: 1;\r\n  /* Equal fixed width so the four slots are uniform and the thumb lines up\r\n     exactly (the control is shrink-to-fit, so flex:1 wouldn't equalise them). */\r\n  flex: 0 0 48px;\r\n  box-sizing: border-box;\r\n  border: none;\r\n  background: transparent;\r\n  color: #82828e;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  padding: 5px 0;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: color 0.2s ease;\r\n}\r\n.ov-range-btn:hover {\r\n  color: #5616ea;\r\n}\r\n.ov-range-btn.active {\r\n  color: #5616ea;\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .ov-range-thumb {\r\n    transition: none;\r\n  }\r\n}\r\n.ov-activity-total {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  line-height: 1.1;\r\n}\r\n.ov-activity-total-num {\r\n  font-size: 1.55rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.ov-activity-total-lbl {\r\n  font-size: 12px;\r\n  color: #82828e;\r\n}\r\n.ov-chart {\r\n  height: 220px;\r\n  margin-top: 6px;\r\n}\r\n.ov-chart-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #c8c8d2;\r\n  font-size: 22px;\r\n}\r\n.ov-chart-tooltip {\r\n  background: #20202a;\r\n  color: #fff;\r\n  border-radius: 7px;\r\n  padding: 6px 10px;\r\n  font-size: 12px;\r\n}\r\n.ov-chart-tooltip-date {\r\n  opacity: 0.7;\r\n  font-size: 11px;\r\n  margin-bottom: 1px;\r\n}\r\n.ov-chart-tooltip-value {\r\n  font-weight: 700;\r\n}\r\n.ov-activity-foot {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  border-top: 1px solid #f0f0f4;\r\n  margin-top: 6px;\r\n  padding-top: 12px;\r\n}\r\n.ov-explore {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #f4f1fd;\r\n  color: #5616ea;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n.ov-explore:hover {\r\n  background: #ece5fb;\r\n}\r\n.ov-explore svg {\r\n  font-size: 11px;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ov-explore:hover svg {\r\n  transform: translateX(3px);\r\n}\r\n\r\n/* ── Responsive ────────────────────────────────────────────────────── */\r\n@media (max-width: 820px) {\r\n  /* Belt-and-braces against horizontal overflow: the page never grows wider\r\n     than the viewport, so every card keeps its right padding and nothing runs\r\n     under the screen edge. */\r\n  .ov-page {\r\n    padding: 16px 14px 36px;\r\n    max-width: 100%;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  .ov-actions,\r\n  .ov-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  /* Stack the two panes: playground on top, the cards below. */\r\n  .ov-split {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: auto;\r\n    min-height: 0;\r\n    max-height: none;\r\n    gap: 16px;\r\n  }\r\n  /* Both panes must be allowed to shrink (flex items default to min-width:auto,\r\n     which is what lets inner content force the page wider than the screen). */\r\n  .ov-split-left,\r\n  .ov-split-right {\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: 100%;\r\n  }\r\n  /* Playground: a bounded height so the embedded chat fills it and its input\r\n     stays pinned + visible at the bottom (the chat scrolls internally). */\r\n  .ov-split-left {\r\n    height: 68dvh;\r\n    min-height: 400px;\r\n  }\r\n  /* Cards: a plain full-width stack (grid -> flex; no internal scroll needed). */\r\n  .ov-split-right {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: visible;\r\n    height: auto;\r\n    min-height: 0;\r\n    padding-right: 0;\r\n    gap: 16px;\r\n  }\r\n  .ov-split-right > .ov-activity {\r\n    min-height: 0;\r\n  }\r\n  /* The card is content-height on mobile (no 1fr grid row to fill), so the\r\n     chart's desktop `flex:1 1 auto; height:auto` collapses it to 0 and recharts'\r\n     ResponsiveContainer renders nothing. Give the chart a fixed height back. */\r\n  .ov-split-right > .ov-activity .ov-chart {\r\n    flex: 0 0 auto;\r\n    height: 200px;\r\n    min-height: 200px;\r\n  }\r\n\r\n  /* Activity header stacks so the range switcher + total don't crowd the title.\r\n     The range control stays its natural compact size (NOT full-width) and sits\r\n     on its own row with the total beside it. */\r\n  .ov-activity {\r\n    padding: 18px 16px 14px;\r\n  }\r\n  .ov-activity-head {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 14px;\r\n  }\r\n  .ov-activity-head-right {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-wrap: wrap;\r\n    gap: 12px 14px;\r\n    width: 100%;\r\n  }\r\n  /* Slightly tighter pills so the range + total fit one row even on ~320px. */\r\n  .ov-range-btn {\r\n    flex: 0 0 44px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
